import React from "react";
import { useQueryClient } from "react-query";
import {
  CUSTOMER_INFO,
  EXISTING_LOANREQUEST,
  LOAN_TEMPLATE_INFOS,
} from "../../config/cacheKey";
import {
  CustomerInfo,
  ExistingLoanRequest,
  LoanTemplateInfo,
} from "../../models/loan.model";

export default function ConfirmationCard(props: any) {
  const queryClient = useQueryClient();
  const customerInfos = queryClient.getQueryData<CustomerInfo>(CUSTOMER_INFO);
  const existingLoanRequest = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST
  );
  const loanInfo = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );

  const existingLoanInfo = queryClient.getQueryData<ExistingLoanRequest>(
    EXISTING_LOANREQUEST
  );
  let finalLoanAmount: any;
  if (existingLoanInfo === null) {
    finalLoanAmount = null;
  } else {
    finalLoanAmount = existingLoanInfo?.finalLoanAmount
      ? existingLoanInfo?.finalLoanAmount.toLocaleString()
      : null;
  }

  const loanTemplateInfos = queryClient.getQueryData<LoanTemplateInfo[]>(
    LOAN_TEMPLATE_INFOS
  );

  const finalInstallmentDuration =
    existingLoanRequest?.finalInstallmentDuration;
  const finalInstallmentCount = existingLoanRequest?.finalInstallmentCount;
  const finalStepSpaceByMonth = existingLoanRequest?.finalStepSpaceByMonth;

  // const listloan = loanInfo
  //   ?.filter((item: any) => item.id == existingLoanRequest?.loanTemplateId)
  //   .map((item: any, index: number, array: any) => {
  //     return {
  //       title: item.title,
  //       cardImage: item.cardImage,
  //       id: item.id,
  //       maxAmount: item.maxAmount,
  //       profitPercentage: item.profitPercentage,
  //       expirationDate_Persian: item.expirationDate_Persian,
  //     };
  //   });

  return (
    <div>
      <div className="row">
        <div
          className="col-6 col-md-4  confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <div className="colorTitle textFont16">
            <b>مشخصات تسهیلات:</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>نام طرح: </span>
              <span style={{ color: "#34495E" }}>
                {props.sendFrom == "facility"
                  ? props.value.title
                  : props.value[0].title}{" "}
                <br />
                {props.value.isBySupplierCredit ? (
                  <b
                    style={{
                      textAlign: "right",
                      color: "#990000",
                      fontSize: "10px",
                    }}
                  >
                    &nbsp; &nbsp;(&nbsp;&nbsp;اعتبار باقیمانده:{" "}
                    {props.value.supplierCredit
                      ? props.value.supplierCredit.toLocaleString()
                      : null}
                    &nbsp;ریال)
                  </b>
                ) : (
                  ""
                )}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تامین کننده کالا:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.financialSupplierTitle
                  : props.value[0].financialSupplierTitle}
              </span>
            </div>
            {/* <div>
              <span style={{ color: "#9AAFC4" }}>مبلغ فاکتور  سس(ریال):</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility" ? props.value.finalLoanAmount : finalLoanAmount}
              </span>
            </div> */}
            <div>
              <span style={{ color: "#9AAFC4" }}> فاصله اقساط:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.stepSpace
                  : finalStepSpaceByMonth}
                {/* {finalStepSpaceByMonth} */}
                &nbsp; ماه &nbsp;
                {/* {props.value.finalStepSpaceByMonth}  */}
              </span>
              <span
                style={{
                  paddingRight: "7px",
                  paddingLeft: "7px",
                  color: "#C1C7CB",
                }}
              >
                |
              </span>
              <span style={{ color: "#9AAFC4" }}> مدت دوره :</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.installmentDuration
                  : finalInstallmentDuration}
                &nbsp;ماه &nbsp;
                {/* {finalInstallmentCount} */}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>سود تسهیلات:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.profitPercentage
                  : props.value[0].profitPercentage}
                %
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>مهلت استفاده از تسهیلات:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.expirationDate_Persian
                  : props.value[0].expirationDate_Persian}
              </span>
            </div>
          </div>
        </div>
        <div
          className=" divisionConfirmationCardCmpFirst col-6  col-md-4 confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <div className="colorTitle textFont16">
            {/* {props.title2} */}
            <b>مشخصات کاربر:</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>نام و نام خانوادگی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.customerFullName
                  : customerInfos?.firstName?.concat(
                    " ",
                    customerInfos?.lastName!
                  )}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>کد ملی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.customerNationalCode
                  : customerInfos?.nationalCode}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تاریخ تولد:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.birthDatePersian
                  : customerInfos?.birthDate_Persian}
                {/* {customerInfos?.birthDate_Persian} */}
                {/* {props.value.birthDatePersian} */}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>تلفن همراه:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.customerMobileNumber
                  : customerInfos?.cellPhone}
                {/* {customerInfos?.cellPhone} */}
                {/* {props.value.customerMobileNumber} */}
              </span>
            </div>
          </div>
        </div>
        <div
          className="divisionConfirmationCardCmp col-6  col-md-4 confirm"
          style={{
            position: "relative",
            display: "inline-block",
            lineHeight: "35px",
            paddingRight: "45px",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <div className="colorTitle textFont16">
            {/* {props.title3} */}
            <b>مشخصات محل سکونت :</b>
          </div>
          <div className="textFont14">
            <div>
              <span style={{ color: "#9AAFC4" }}>کد پستی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.customerPostalCode
                  : customerInfos?.postalCode}
                {/* {customerInfos?.postalCode} */}
                {/* {props.value.customerPostalCode} */}
              </span>
            </div>
            <div>
              <span style={{ color: "#9AAFC4" }}>آدرس پستی استعلامی:</span>
              <span style={{ color: "#34495E" }}>
                {" "}
                {props.sendFrom == "facility"
                  ? props.value.customerAddress
                  : customerInfos?.address}
                {/* {customerInfos?.address} */}
                {/* {props.value.customerAddress} */}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <Grid
    //   container
    //   direction="row"
    //   spacing={3}
    //   style={{ width: "98%", margin: "auto" }}
    // >
    //   {props == null || props.value.length == 0 ? (
    //     <></>
    //   ) : (
    //     <Grid item xs={4} style={{ justifyContent: "center", display: "flex" }}>
    //       <div
    //         style={{
    //           position: "relative",
    //           display: "inline-block",
    //           lineHeight: "35px",
    //         }}
    //       >
    //         <div className="colorTitle textFont16">
    //           <b>مشخصات تسهیلات:</b>
    //         </div>
    //         <div className="textFont14">
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}>نام طرح: </span>
    //             <span style={{ color: "#34495E" }}>
    //               {props.value.title}{" "}
    //             </span>
    //           </div>
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}>تامین کننده مالی:</span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {props.value[0].financialSupplierTitle}
    //             </span>
    //           </div>
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}>مبلغ فاکتور  (ریال):</span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {finalLoanAmount}
    //             </span>
    //           </div>
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}> فاصله اقساط:</span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {finalStepSpaceByMonth}ماهه
    //             </span>
    //              <span style={{paddingRight:'7px',paddingLeft:'7px',color:'#C1C7CB'}}>
    //               |
    //               </span>
    //             <span style={{ color: "#9AAFC4" }}> تعداد اقساط:</span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {finalInstallmentCount}
    //             </span>
    //           </div>
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}>سود تسهیلات:</span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {props.value[0].profitPercentage} %
    //             </span>
    //           </div>
    //           <div>
    //             <span style={{ color: "#9AAFC4" }}>
    //               مهلت استفاده از تسهیلات:
    //             </span>
    //             <span style={{ color: "#34495E" }}>
    //               {" "}
    //               {props.value[0].expirationDate_Persian}
    //             </span>
    //           </div>
    //         </div>
    //       </div>
    //     </Grid>
    //   )}

    //   <Grid item xs={4}  style={{ justifyContent: "center" }}>
    //     <div className="divisionConfirmationCardCmp">
    //       <div className="colorTitle textFont16">
    //         {/* {props.title2} */}
    //         <b>مشخصات کاربر:</b>
    //       </div>
    //       <div className="textFont14">
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>نام و نام خانوادگی:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.firstName} {customerInfos?.lastName}
    //           </span>
    //         </div>
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>کد ملی:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.nationalCode}
    //           </span>
    //         </div>
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>تاریخ تولد:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.birthDate_Persian}
    //           </span>
    //         </div>
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>تلفن همراه:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.cellPhone}
    //           </span>
    //         </div>
    //       </div>
    //     </div>
    //   </Grid>
    //   <Grid item xs={4}  style={{ justifyContent: "center" }}>
    //     <div className="divisionConfirmationCardCmp">
    //       <div className="colorTitle textFont16">
    //         {/* {props.title3} */}
    //         <b>مشخصات محل سکونت :</b>
    //       </div>
    //       <div className="textFont14">
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>کد پستی:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.postalCode}
    //           </span>
    //         </div>
    //         <div>
    //           <span style={{ color: "#9AAFC4" }}>آدرس پستی استعلامی:</span>
    //           <span style={{ color: "#34495E" }}>
    //             {" "}
    //             {customerInfos?.address}
    //           </span>
    //         </div>
    //       </div>
    //     </div>
    //   </Grid>
    // </Grid>
  );
}
